import { createContext, useContext } from 'react';
import { DefaultExtensionConfig } from './config/constants';
export const ComposerConfigContext = createContext({
    extensions: DefaultExtensionConfig,
});
export const useComposerConfig = () => useContext(ComposerConfigContext);
//# sourceMappingURL=ComposerConfigContext.js.map